import React from "react";
import { IconProps } from "../constants/GlobalTypesAndEnumsAndConstants";
import { colors, lightColorWithDarkTheme, lightThemeColorValues } from "../constants/GlobalStyles";

// A 1px ring: on a dark tinted panel the brand green is too faint at that width, so there it is the lighter
// green that small words on a tint take
const RING_COLOR = lightColorWithDarkTheme(
  lightThemeColorValues.primaryAction.default,
  colors.primaryAction.textOnTint
);

const CircleCheckbox = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="7.5" fill={props.color || colors.surface.white} stroke={RING_COLOR} />
  </svg>
);

export default CircleCheckbox;
